import { BehaviorSubject, Observable } from "rxjs";
import { UiOptions } from "../models/uiOptions";
import ResizeObserver from 'resize-observer-polyfill';

class UiServiceController {
    private currentOptionsSource: BehaviorSubject<UiOptions> = new BehaviorSubject<UiOptions>({});
    private isMobileSource: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private isTabletSource: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    currentOptions: Observable<UiOptions> = this.currentOptionsSource.asObservable();
    isMobile: Observable<boolean> = this.isMobileSource.asObservable();
    isTablet: Observable<boolean> = this.isTabletSource.asObservable();

    ro: ResizeObserver = new ResizeObserver((entries) => this.onResize(entries));

    constructor() {
        this.ro.observe(window.document.body);
    }

    onResize(_entries: ResizeObserverEntry[]) {
        const vpWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        if (vpWidth < 768) {
            if (this.isMobileSource.value === false) {
                this.isMobileSource.next(true);
            }
            if (this.isTabletSource.value === false) {
                this.isTabletSource.next(true);
            }
        } else if (vpWidth < 1024) {
            if (this.isMobileSource.value === true) {
                this.isMobileSource.next(false);
            }
            if (this.isTabletSource.value === false) {
                this.isTabletSource.next(true);
            }
        } else {
            if (this.isMobileSource.value === true) {
                this.isMobileSource.next(false);
            }
            if (this.isTabletSource.value === true) {
                this.isTabletSource.next(false);
            }
        }
    }

    setOffsetTop(offsetTop: number) {
        const newParams = { ...this.currentOptionsSource.value, ...{ offsetTop } };
        this.currentOptionsSource.next(newParams);
    }

    setSearchHeight(searchHeight: number) {
        const newParams = { ...this.currentOptionsSource.value, ...{ searchHeight } };
        this.currentOptionsSource.next(newParams);
    }
}

export const UiService = new UiServiceController();

